module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$route.fullPath == '/home' ? 'header-box' : 'header-box-bg'
  }, [_c('div', [_c('header', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "w-box"
  }, [_c('div', {
    staticClass: "nav-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/login",
      "title": "医小智-牙嗖嗖"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-box"
  }, [_c('div', {
    class: _vm.user.isLogin == true ? 'nav-list-login' : 'nav-list'
  }, _vm._l((_vm.navList), function(item, i) {
    return _c('li', {
      key: i
    }, [_c('a', {
      class: {
        active: _vm.common.navSelect.navIndex === i
      },
      on: {
        "click": function($event) {
          return _vm.changeNav(i, item)
        }
      }
    }, [_vm._v(_vm._s(item.navLabel))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right-box"
  }, [(!_vm.user.isLogin) ? _c('div', {
    staticClass: "nav-logo2"
  }, [_c('span', {
    staticClass: "login-txt",
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login",
      "title": "医小智-牙嗖嗖"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "aside",
    staticClass: "nav-aside",
    class: {
      fixed: _vm.st
    },
    style: (_vm.user.isLogin == true ? 'opacity:1;' : 'opacity:0;')
  }, [_c('div', {
    staticClass: "user pr"
  }, [_c('router-link', {
    attrs: {
      "to": "/user"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), (_vm.user.isLogin) ? _c('div', {
    staticClass: "nav-user-wrapper pa"
  }, [_c('div', {
    staticClass: "nav-user-list"
  }, [_c('ul', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('li', {
    staticClass: "nav-user-avatar"
  }, [_c('div', [_c('span', {
    staticClass: "avatar",
    style: (_vm.user ? (_vm.user.avatar ? 'background-image:url(' + _vm.user.avatar + ')' : 'background-image:url(/static/images/default.png)') : 'background-image:url(/static/images/smile.png)')
  })]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.user ? _vm.user.loginName : ''))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.clickLogout
    }
  }, [_vm._v("退出账号")])])])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "positionMsg",
    staticClass: "shop pr",
    on: {
      "mouseover": function($event) {
        return _vm.cartShowState(true)
      },
      "mouseout": function($event) {
        return _vm.cartShowState(false)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cart"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cart-num"
  }, [_c('i', {
    staticClass: "num",
    class: {
      no: _vm.totalNum <= 0, move_in_cart: _vm.cart.receiveInCart
    }
  }, [_vm._v(_vm._s(_vm.totalNum))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cart.showCart),
      expression: "cart.showCart"
    }],
    staticClass: "nav-user-wrapper pa active"
  }, [_c('div', {
    staticClass: "nav-user-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalNum),
      expression: "totalNum"
    }],
    staticClass: "full"
  }, [_c('div', {
    staticClass: "nav-cart-items"
  }, [_c('ul', _vm._l((_vm.cart.cartList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "cart-item-inner"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.openProduct(item.productId)
        }
      }
    }, [_c('div', {
      staticClass: "item-thumb"
    }, [_c('img', {
      attrs: {
        "src": item.productImg
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-desc"
    }, [_c('div', {
      staticClass: "cart-cell"
    }, [_c('h4', [_c('a', {
      attrs: {
        "href": ""
      },
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "item-num"
    }, [_vm._v("x\n                                           " + _vm._s(item.productNum))])])])]), _vm._v(" "), _c('div', {
      staticClass: "del-btn del",
      on: {
        "click": function($event) {
          return _vm.delGoods(item.productId)
        }
      }
    }, [_vm._v("删除")])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "nav-cart-total"
  }, [_c('p', [_vm._v("共 "), _c('strong', [_vm._v(_vm._s(_vm.totalNum))]), _vm._v(" 件商品")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.totalNum),
      expression: "!totalNum"
    }],
    staticClass: "cart-con",
    staticStyle: {
      "height": "313px",
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您的购物车竟然是空的!")])])])])], 1)])])]), _vm._v(" "), _c('div', {
    class: _vm.user.isLogin == true ? 'bot-login' : 'bot-hr'
  })]), _vm._v(" "), (_vm.$route.fullPath != '/home') ? _vm._t("nav", function() {
    return [(_vm.$route.fullPath != '/downLoad') ? _c('div', {
      staticClass: "nav-sub",
      class: {
        fixed: _vm.st
      }
    }, [_c('div', {
      staticClass: "nav-sub-wrapper",
      class: {
        fixed: _vm.st
      }
    }, [_c('div', {
      staticClass: "w"
    }, [_c('ul', {
      staticClass: "nav-sub-list"
    }, _vm._l((_vm.navSubList), function(item, i) {
      return _c('li', {
        key: i
      }, [_c('a', {
        class: {
          active: _vm.common.navSelect.navSubIndex === i
        },
        on: {
          "click": function($event) {
            return _vm.changeSubNav(i, item)
          }
        }
      }, [_vm._v(_vm._s(item.navLabel))])])
    }), 0)])])]) : _vm._e()]
  }) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "header-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px 20px"
    }
  }, [_vm._v("认证申请")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "space-around",
      "height": "300px"
    }
  }, [_c('div', {
    staticClass: "item itme1"
  }, [_c('a', {
    on: {
      "click": _vm.factory
    }
  }, [_c('div', {
    staticClass: "t fiex f-18"
  }, [_c('div', {
    staticClass: "t2 center"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/zc11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("诊所/工厂认证")])])]), _vm._v(" "), _c('div', {
    staticClass: "item itme2"
  }, [_c('a', {
    on: {
      "click": _vm.designer
    }
  }, [_c('div', {
    staticClass: "t fiex f-18"
  }, [_c('div', {
    staticClass: "t2 center"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/zc22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("设计师认证")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4f8e0ae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/MHeader.vue
// module id = 667
// module chunks = 0